import React from "react";

// Curated calendar-date banner: what the day IS (every observance — some days carry
// several) plus an interesting fact. Renders above the tiered date facets.
export default function RagDateBanner({ date }) {
  if (!date) return null;
  return (
    <div className="rounded-lg border border-primaryBlue bg-primaryBlue bg-opacity-[0.06] p-4 mb-8">
      <h2 className="text-xl md:text-2xl font-extrabold text-primaryDark">{date.name}</h2>
      {(date.observances || []).length > 0 && (
        <ul className="mt-2 space-y-1">
          {date.observances.map((o, i) => (
            <li key={i} className="text-primaryDark flex gap-2">
              <span aria-hidden="true">•</span>
              <span>{o}</span>
            </li>
          ))}
        </ul>
      )}
      {date.fact ? (
        <p className="mt-3 text-sm italic text-primaryDark opacity-80">{date.fact}</p>
      ) : null}
    </div>
  );
}
